import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { SubmitButtonModule } from '@app/shared/ui/components/buttons/submit-button/module/submit-button.module';
import { TimePickerComponent } from '@app/shared/ui/components/inputs/time-picker/time-picker.component';
import { UiModule } from '@ui';

@NgModule({
	declarations: [TimePickerComponent],
	imports: [TranslateModule, CommonModule, UiModule, NgxMaterialTimepickerModule, SubmitButtonModule],
	exports: [TimePickerComponent]
})
export class TimePickerModule {}
